import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import filter from 'lodash/filter';
import { mapGetters } from 'vuex';
import { buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates } from '~/helpers/seo-helpers';
export default {
  name: 'CategorySeo',
  props: {
    seo: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    hash: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    partialPath: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locales: 'i18n/locales',
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    facet() {
      return this.seo.facet_opened ? this.seo.facet_opened : '';
    }

  }),

  head() {
    return {
      title: "".concat(this.title, " | Maisons du Monde"),
      link: filter([buildCategoryPrevLink(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryCanonical(this.locale, this.baseURL, this.partialPath, this.page, this.facet), buildCategoryNextLink(this.locale, this.baseURL, this.partialPath, this.total, this.page, this.facet), ...buildCategoryAlternates(this.baseURL, this.seo.alternate, this.hash, this.page, this.facet)], entry => entry !== null),
      meta: [this.seo.is_indexed ? {} : {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      }, {
        name: 'description',
        content: this.seo.meta_description
      }]
    };
  },

  render: h => h(null)
};